import { render, staticRenderFns } from "./fbClassifyComp.vue?vue&type=template&id=6fb2651e&scoped=true&"
import script from "./fbClassifyComp.vue?vue&type=script&lang=js&"
export * from "./fbClassifyComp.vue?vue&type=script&lang=js&"
import style0 from "./fbClassifyComp.vue?vue&type=style&index=0&id=6fb2651e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb2651e",
  null
  
)

export default component.exports